<app-status-pill
  *ngIf="classification"
  [name]="classification.name">
</app-status-pill>